export function sourceReducer(state: string | undefined = ''): string | undefined {
  return state;
}
